import {useState} from 'react'
import {CalendarDays, Gauge, Filter, Plus} from 'lucide-react'
import {useApp} from '../../context/AppContext'
import {formatDate} from '../../utils/helpers'
import PageHeader from '../common/PageHeader'
import StatsGrid from './StatsGrid'
import ActivityFeed from './ActivityFeed'
import TaskDistribution from './TaskDistribution'
import UpcomingDeadlines from './UpcomingDeadlines'
import FocusQueue from './FocusQueue'
import NewTaskForm from '../board/NewTaskForm'

export default function Dashboard() {
  const {state} = useApp()
  const {currentUser, loading} = state
  const [boardId, setBoardId] = useState('')
  const [showNewTask, setShowNewTask] = useState(false)
  const selectedBoardId = state.boards.some((board) => board.id === boardId) ? boardId : ''
  const scopedTasks = selectedBoardId
    ? state.tasks.filter((task) => task.boardId === selectedBoardId)
    : state.tasks
  const creationBoard =
    state.boards.find((board) => board.id === selectedBoardId) ||
    state.boards.find((board) => board.id === state.currentBoardId) ||
    state.boards[0]
  const hour = new Date().getHours()
  const greeting = hour < 12 ? 'Bom dia' : hour < 18 ? 'Boa tarde' : 'Boa noite'

  if (loading && !state.lastLoadedAt) {
    return (
      <div className='devops-page space-y-6 animate-pulse' aria-label='Carregando painel'>
        <div className='h-20 bg-white/70 rounded-2xl border border-slate-200' />
        <div className='grid grid-cols-2 lg:grid-cols-4 gap-4'>
          {[1, 2, 3, 4].map((item) => (
            <div key={item} className='h-32 bg-white/70 rounded-2xl border border-slate-200' />
          ))}
        </div>
        <div className='h-72 bg-white/70 rounded-2xl border border-slate-200' />
      </div>
    )
  }

  if (!currentUser) return null

  return (
    <div className='devops-page space-y-5 md:space-y-6'>
      <PageHeader
        eyebrow='Visão geral'
        icon={Gauge}
        title={`${greeting}, ${currentUser.name.split(' ')[0]}`}
        description='Acompanhe o ritmo das entregas, identifique gargalos e priorize o que precisa de atenção hoje.'
        actions={
          creationBoard && (
            <button
              type='button'
              className='devops-primary-button'
              onClick={() => setShowNewTask(true)}
            >
              <Plus size={16} /> Nova tarefa
            </button>
          )
        }
        meta={
          <>
            <span>
              <CalendarDays size={11} />
              {formatDate(new Date().toISOString())}
            </span>
            <span>
              {scopedTasks.filter((task) => task.status !== 'done').length} tarefas pendentes
            </span>
          </>
        }
      />

      <div className='devops-dashboard-scope'>
        <label htmlFor='devops-dashboard-board'>
          <Filter size={15} /> Acompanhar quadro
        </label>
        <select
          id='devops-dashboard-board'
          value={selectedBoardId}
          onChange={(event) => setBoardId(event.target.value)}
        >
          <option value=''>Todos os quadros</option>
          {state.boards.map((board) => (
            <option key={board.id} value={board.id}>
              {board.name}
            </option>
          ))}
        </select>
        <span>Filtre os indicadores e as pendências por quadro.</span>
      </div>
      <StatsGrid tasks={scopedTasks} boardCount={selectedBoardId ? 1 : state.boards.length} />
      <FocusQueue tasks={scopedTasks} boardId={selectedBoardId} />
      <TaskDistribution tasks={scopedTasks} boardId={selectedBoardId} />

      <div className='grid grid-cols-1 xl:grid-cols-2 gap-4 md:gap-5'>
        <ActivityFeed tasks={scopedTasks} />
        <UpcomingDeadlines tasks={scopedTasks} />
      </div>
      {creationBoard && showNewTask && (
        <>
          <NewTaskForm
            boardId={creationBoard.id}
            initialStatus={creationBoard.columns[0]?.status || 'todo'}
            onClose={() => setShowNewTask(false)}
          />
        </>
      )}
    </div>
  )
}
